import { render, staticRenderFns } from "./afflatus.vue?vue&type=template&id=72531ebf&scoped=true"
import script from "./afflatus.vue?vue&type=script&lang=js"
export * from "./afflatus.vue?vue&type=script&lang=js"
import style0 from "./afflatus.vue?vue&type=style&index=0&id=72531ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72531ebf",
  null
  
)

export default component.exports